// @flow

import React from 'react'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import muiTheme from '@vimcar/shared-components/utils/muiTheme'
import ErrorBoundary from '@vimcar/shared-components/components/ErrorBoundary'
import DialogsProvider from '@vimcar/shared-components/components/DialogsProvider'
import ViewportProvider from '@vimcar/shared-components/components/ViewportProvider'

import Routes from './routes'
import StoresProvider from '#components/StoresProvider'
import RequestProvider from '#components/RequestProvider'
import PermissionsProvider from '#components/PermissionsProvider'
import i18n from '#utils/i18n'
import './styles/html.css'
import './styles/joyride.global.css'

const App = () => (
  // $FlowFixMe
  <ErrorBoundary
    environment={process.env.NODE_ENV || 'development'}
    errorTitle={i18n.t('global.app-error')}
    release={global.PACKAGE_VERSION}
    >
    <RequestProvider>
      <StoresProvider>
        <PermissionsProvider>
          <MuiThemeProvider muiTheme={muiTheme}>
            <ViewportProvider>
              <DialogsProvider>
                <Routes/>
              </DialogsProvider>
            </ViewportProvider>
          </MuiThemeProvider>
        </PermissionsProvider>
      </StoresProvider>
    </RequestProvider>
  </ErrorBoundary>
)

export default App
